module.exports = __webpack_public_path__ + "img/best-seller-trigger.027d83ff.svg";